<script>
    import {pageName} from '../store';
    const heading = [
        {
            heading: 'Home',
            link: '/',
        },
        {
            heading: 'Gamers',
            link: '/gamers',
        },
        {
            heading: 'Artists & Musicians',
            link: '/artist',
        },
        {
            heading: 'Storytellers',
            link: '/story',
        },
        {
            heading: 'Performers',
            link: '/performance',
        },
    ];
    const subHeading = [
        {
            text: 'Technical Creators',
            link: '/Create',
        },
        {
            text: 'Advertisers',
            link: '/AdvertPage',
        },
        {
            text: 'Investors',
            link: '/InvestPage',
        },
        {
            text: 'Team',
            link: '/Team',
        },
        {
            text: 'Careers',
            link: 'https://corp.opus.ai/jobs',
        },
    ];
    let dropDown;
    let toggler = 'flex';
    let left;
    let right;
    let lineheight1;
    let lineheight2;
    let sec = '0s';
    let secdelay;
    let textHide;
    const param = window.location.href;
    const lastSegment = param.split('/').pop();
    if (param != 'demo') {
        pageName.update((n) => lastSegment);
    }
    
</script>

<section>
    <div class="main-div">
        <div id="shape">
            <div class="left" bind:this={left} />
            <div class="right" bind:this={right} />
            <div class="img-div">
                
                <div class="logo">
                    <a href="/">
                        <img src="images/mobileNavbar/opuslogomob.svg" alt="" />
                    </a>
                    
                </div>
                
                <div
                    class="toggler"
                    style="display:{toggler};"
                    role="presentation"
                    on:click={() => {
                        dropDown.style.height = '100vh';
                        dropDown.style.paddingTop = '33vw';
                        dropDown.style.transitionDuration = '1s';
                        toggler = 'none';
                        left.style.background = 'transparent';
                        left.style.transform = 'skew(0deg, 25deg)';
                        right.style.transform = 'skew(0deg, -25deg)';
                        left.style.zIndex = '1';
                        right.style.zIndex = '1';
                        left.style.height = '100vh';
                        right.style.height = '100vh';
                        right.style.background = 'transparent';
                        left.style.transition = '1s';
                        // left.style.transitionDelay = '0.2s';
                        right.style.transition = '1s';
                        // right.style.transitionDelay = '0.2s';
                        lineheight1 = '7vw';
                        lineheight2 = '4.673vw';
                        sec = '0.4s';
                        // secdelay = '0.3s';
                        textHide.style.opacity = '1';
                        // textHide.style.transitionDelay = '0.22s';
                    }}
                >
                    <svg
                        width="3.855vw"
                        height="    height: 3.5vw;"
                        viewBox="0 0 17 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <line
                            x1="3"
                            y1="1"
                            x2="15.4997"
                            y2="1"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                        />
                        <line
                            x1="7.50391"
                            y1="6.5"
                            x2="15.5037"
                            y2="6.5"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                        />
                        <line
                            x1="1"
                            y1="12"
                            x2="15.4997"
                            y2="12"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                        />
                    </svg>
                </div>
            </div>
        </div>
        <div
            class="second-div"
            role="presentation"
            bind:this={dropDown}
            on:click={() => {
                dropDown.style.height = '0vh';
                dropDown.style.paddingTop = '0vw';
                dropDown.style.transitionDuration = '1s';
                // dropDown.style.transitionDelay = '0.2s';
                left.style.transform = 'skew(0deg, 6deg)';
                right.style.transform = 'skew(0deg, -6deg)';
                toggler = 'flex';
                left.style.height = '14.391vh';
                right.style.height = '14.391vh';
                left.style.background = 'black';
                right.style.background = 'black';
                left.style.transition = '0.8s';
                // left.style.transitionDelay = '0.1s';
                right.style.transition = '0.8s';
                // right.style.transitionDelay = '0.1s';
                // lineheight1 = '0vw';
                // lineheight2 = '0vw';
                sec = '0.1s';
                secdelay = '0.2s';
                textHide.style.opacity = '0';
                textHide.style.transition = '0.2s';
                textHide.style.transitionDelay = '0.3s';
            }}
        >
            <div bind:this={textHide}>
                <div style="padding-left:7.710vw;">
                    <div class="heading">
                        {#each heading as data, i}
                            <p
                                style="line-height: {lineheight1};transition:{sec};transition-delay:{secdelay};"
                            >
                            <a href={data.link}>
                                {data.heading}
                            </a>
                            </p>
                        {/each}
                    </div>

                    <hr />

                    <div class="subheading">
                        {#each subHeading as data}
                            <p
                                style="line-height: {lineheight2};transition:{sec};transition-delay:{secdelay};"
                                >
                                <a href={data.link}>
                                    {data.text}
                                </a>
                                
                            </p>
                        {/each}
                    </div>
                </div>

                <a href="/demo">
                    <div class="btn" >
                        <button> Watch Demo </button>
                    </div>
                </a>
                <div class="arrow">
                    <p>></p>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    #shape {
        position: relative;
        text-align: center;
        height: 100%;
        width: 100%;
    }
    .left {
        position: absolute;
        z-index: 2;
        top: -10vw;
        left: 0;
        height: 24.391vw;
        width: 50.2%;
        background-color: black;
        transform: skew(0deg, 6deg);
    }
    .right {
        position: absolute;
        z-index: 2;
        top: -10vw;
        right: 0;
        /* height: max(14.391vh,21.371vw); */
        height: 24.391vw;
        width: 50.1%;
        /* border-radius: 0vw 0vw 0vw 1vw; */
        background-color: black;
        transform: skew(0deg, -6deg);
    }
    .img-div {
        position: relative;
        /* display: flex; */
    width: 100vw;
    /* justify-content: space-between; */
    float: right;
    /* padding-right: 6.528vw; */
    margin-top: 2vh;
    }
    .logo {
        z-index: 3;
    /* position: absolute; */
    width: fit-content;
    /* margin-left: 1.5vw; */
    position: relative;
    margin: auto;
    }
    .logo img {
        width: auto;
        height: 8.645vw;
    }
    .toggler {
        z-index: 2;
    box-sizing: border-box;
    /* align-items: flex-start; */
    position: absolute;
    /* display: flex; */
    right: 7vw;
    /* margin-top: 0.2vh; */
    top: 0.5vh;
    }
    .second-div {
        width: 100%;
        height: 0%;
        background-color: rgba(0, 0, 0, 0.9);
        position: fixed;
        padding-top: 0vw;
        box-sizing: border-box;
        z-index: 1;
        overflow: scroll;
    }
    hr {
        width: 71.495vw;
        margin: 0;
        border: none;
        background-color: white;
        height: 0.058vw;
        margin-top: 11.215vw;
        margin-bottom: 9.346vw;
    }
    .heading p {
        color: white;
        font-size: 5.607vw;
        font-weight: 600;
        font-family: "Orbitron";
        margin-bottom: 6.542vw;
        line-height: 0vw;
    }
    .subheading p {
        color: white;
        font-size: 3.738vw;
        font-weight: 400;
        font-family: "Orbitron";
        margin-bottom: 5.841vw;
        line-height: 0vw;
    }
    .btn {
        margin-top: 23.598vw !important;
        margin-bottom: 12.617vw !important;
        margin: auto;
        width: fit-content;
    }

    .btn button {
        width: 42.757vw;
        height: 10.28vw;
        border: 0.058vw solid white;
        border-radius: 2.336vw;
        background-color: transparent;
        color: white;
        font-size: 2.804vw;
        font-weight: 700;
        font-family: "Orbitron";
    }
    .arrow p {
        font-family: "Oranienbaum";
        color: white;
        transform: rotate(-90deg);
        font-size: 4.673vw;
        font-weight: 900;
    }
    .arrow {
        width: 4.558vw;
        height: 5.841vw;
        margin: auto;
    }
</style>
